import styles from './formulari.module.scss';
import Icona from 'components/corporatiu/ui/Icona';

type FormulariRespostaProps = {
    status?: string;
    titol?: string;
    descripcio?: string;
    [key: string]: any;
};

export default function FormulariResposta(props: FormulariRespostaProps) {
    const { status = 'ok', titol, descripcio } = props;

    const missatge = (
        <>
            <h2 className={styles.titol}>{titol}</h2>
            <div className={styles.subtitol} dangerouslySetInnerHTML={{ __html: descripcio || '' }} />
        </>
    );

    if (status === 'ok') {
        return (
            <div className={styles.formResposta}>
                <div className={styles.left}>
                    <Icona
                        className={styles.ok}
                        icona='ic_verificat'
                        alt='ok'
                        isBlanc={false}
                        path='corporatiu'
                        mida='24'
                        inline={true}
                    />
                </div>
                <div className={styles.formRespOk}>{missatge}</div>
            </div>
        );
    } else {
        return (
            <div className={styles.formResposta}>
                <div className={styles.left}>
                    <Icona
                        className={styles.ko}
                        icona='ic_alerta'
                        alt='ko'
                        isBlanc={false}
                        path='corporatiu'
                        mida='24'
                        inline={true}
                    />
                </div>
                <div className={styles.formRespKo}>{missatge}</div>
            </div>
        );
    }
}
